import React from 'react';
import ReactWeather, { useOpenWeather } from 'react-open-weather';

function WeatherWidget() {
  const {
    data,
    isLoading,
    errorMessage,
  } = useOpenWeather({
    key: 'eed9035a1d577a437663e97553b66aef',
    lat: '-27.666782',
    lon: '153.176232',
    lang: 'en',
    unit: 'metric',
  });

  return (
    <div className="sidebar-widget-area">
      <h5 className="title">Weather Companion</h5>
      <div className="widget-content">
        <ReactWeather
          isLoading={isLoading}
          errorMessage={errorMessage}
          data={data}
          lang="en"
          locationLabel="Loganholme"
          unitsLabel={{ temperature: 'C', windSpeed: 'Km/h' }}
          showForecast
        />
      </div>
    </div>
  );
}

export default WeatherWidget;
